import { render, staticRenderFns } from "./CesShopTypeList.vue?vue&type=template&id=2560c7e8&scoped=true"
import script from "./CesShopTypeList.vue?vue&type=script&lang=js"
export * from "./CesShopTypeList.vue?vue&type=script&lang=js"
import style0 from "./CesShopTypeList.vue?vue&type=style&index=0&id=2560c7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2560c7e8",
  null
  
)

export default component.exports